module.exports = __webpack_public_path__ + "assets/f02d6a1fbb016668f6150ef946d2a159.png";